import { Seo } from "@/components/seo";
import { cn } from "@/lib/utils";

type OnboardingHeaderProps = {
  title: string;
  description?: string;
  Icon?: React.ComponentType<{ className?: string }>;
  className?: string;
  actions?: React.ReactNode;
};

export function OnboardingHeader({
  title,
  description,
  Icon,
  className,
  actions,
}: OnboardingHeaderProps) {
  return (
    <div className={cn("", className)}>
      <Seo title={title} />
      {Icon && (
        <div className="mb-6 inline-flex items-center justify-center rounded-xl border border-border bg-background p-3.5 shadow-sm">
          <Icon className="h-6 w-6 text-foreground" />
        </div>
      )}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-foreground lg:text-3xl">
          {title}
        </h1>
        {actions && actions}
      </div>
      {description && (
        <p className="text-md mt-1 text-muted-foreground lg:mt-3">
          {description}
        </p>
      )}
    </div>
  );
}
